import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import VolunteerModal from './VolunteerModal';

class VolunteerHitListView extends React.Component {

    constructor(props){
        super(props);

    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){

        const renderSelected  = ()=>{
            if(!this.props.selectedRef) return null;
            return (
                <VolunteerModal></VolunteerModal>
            )
            
        }

        return (
            <div className="VolunteerHitListView">
                {renderSelected()}
                {this.props.children}
                <style jsx>{`
                    .VolunteerHitListView {
                        max-width: 800px;
                        margin:auto;
                    }
                `}</style>
                
            </div>
        )
    }
}

VolunteerHitListView.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
        selectedRef : state.volunteer.selectedRef,
    };
}

export default  connect(mapStateProps, {  })(VolunteerHitListView);



// WEBPACK FOOTER //
// ./src/components/common/VolunteerHitListView.js